<template lang="pug">
#facility-edit(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span 施設情報修正
    .box-body.register-body
      .note
        span 施設情報はご家族・施設関係者がLINEから見ることが出来ます。
      FormInput(
        v-model="name" key-name="施設名" name="facility-name"
        type="text" placeholder="施設名"
        :maxlength="100"
        :validation-rules="{ required: true, max: 100 }" required)
      FormInputPostalCode(
        :postalCode1.sync="postalCode1" :postalCode2.sync="postalCode2" key-name="郵便番号" name="postal-codes"
        :validation-rules="{ required: true, custom_numeric: true }" required)
      FormInputSelect(
        v-model="prefectureCode" key-name="都道府県" name="prefecture-code"
        :options="_prefectureOptions"
        :validation-rules="{ required: true }"
        :styles="{ 'width': '140px', 'max-width': '140px', 'min-width': '140px' }"
        @change="changePrefecture"
        required)
      FormInputSelect(
        v-model="municipalityCode" key-name="市区町村" name="municipality-code"
        :options="_municipalityOptions"
        :validation-rules="{ required: true }"
        :styles="{ 'width': '270px', 'max-width': '270px', 'min-width': '270px' }"
        @change="changeMunicipality"
        required)
      FormInput(
        v-model="streetAddress" key-name="丁目番地号" name="street-address"
        type="text" placeholder="例：西新宿１－２６－１"
        :maxlength="38"
        :validation-rules="{ required: true, max: 38 }" required)
      FormInput(
        v-model="tel" key-name="電話番号" name="facility-tel"
        type="text" placeholder="電話番号"
        :maxlength="13"
        :validation-rules="{ required: true, max: 13, tel: true }" required)
      FormInput(
        v-model="url" key-name="ホームページ" name="facility-url"
        type="text" placeholder="ホームページ"
        :maxlength="10000"
        :validation-rules="{ url: { require_protocol: ['http', 'https'] }, max: 10000 }")
      FormFile(
        v-model="imageFile" key-name="画像" name="image-file"
        :file-name.sync="imageName"
        mimetype="image/*" width="450px"
        :validationRules="{ required: true }"
        clip required)
        template(v-slot:question)
          HelpIcon(:title="'選択可能なファイルについて'" :text="'jpegもしくはpngを選択可能です。'")
      FormImage(v-show="imageUrl" key-name="プレビュー" v-model="imageUrl" style="width:320px;")

      FormInputSelect(
        v-model="facilityCategory" key-name="施設種別" name="facility-category"
        :options="_facilityCategoryOptions"
        :styles="{ 'width': '300px', 'max-width': '300px', 'min-width': '300px' }")

      //- 並び順に指定があるため、共通コンポーネントは使えない
      .register-row
        .register-group
          .register-key
            .left-side.d-flex
              span.key-name 介護度
          .register-value.form-input-checkboxes
            .d-flex.flex-column
              .d-flex.flex-row.flex-wrap
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel1000" name="careLevel1000" :value="true" type="checkbox")
                  span.text(style="margin-left:0;") 自立
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel1010" name="careLevel1010" :value="true" type="checkbox")
                  span.text 申請中
              .d-flex.flex-row.flex-wrap
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel2010" name="careLevel2010" :value="true" type="checkbox")
                  span.text(style="margin-left:0;") 要支援１
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel2020" name="careLevel2020" :value="true" type="checkbox")
                  span.text 要支援２
              .d-flex.flex-row.flex-wrap
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel3010" name="careLevel3010" :value="true" type="checkbox")
                  span.text(style="margin-left:0;") 要介護１
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel3020" name="careLevel3020" :value="true" type="checkbox")
                  span.text 要介護２
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel3030" name="careLevel3030" :value="true" type="checkbox")
                  span.text 要介護３
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel3040" name="careLevel3040" :value="true" type="checkbox")
                  span.text 要介護４
                label.register-checkbox-label(style="width:140px;")
                  input(v-model="careLevels.careLevel3050" name="careLevel3050" :value="true" type="checkbox")
                  span.text 要介護５

      .register-row(v-show="errorMessage")
        .register-group
          .register-value
            .error-message {{ errorMessage }}

      //- 生活保護を受け入れるか否か
      FormCheck(v-model="acceptsWelfare" key-name="生活保護" name="accepts-welfare" label="受け入れ可")
      //- 医療・看護体制
      FormInputCheckboxes(v-model="medicalNursings" name="medical-nursings" key-name="医療・看護体制" :options="_medicalNursingsOptions")
      //- 受け入れ条件の補足事項
      FormTextarea(v-model="acceptanceConditions" key-name="受け入れ条件の補足事項" name="acceptance-conditions"
        placeholder="連携他事業所に公開する受け入れ条件の補足事項を入力してください。" :maxlength="1000"
        :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }")

    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons
        button.btn.update-btn(@click="showConfirmUpdateModal" type="button") 更新
        button.btn.cancel-btn(@click="gotoFacility" type="button") キャンセル

  OkCancelModal(v-model="showUpdateModal" title="施設情報を更新しますか？" @ok="updateFacility")
  OkModal(v-model="showUpdateSuccessModal" title="更新に成功しました。" @ok="gotoFacility")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Watch, Inject, Vue } from "vue-property-decorator";
import { userStore, regionsStore } from "@/store/store";

import Setting from "../../../../public/setting.json";
import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import FacilitiesService, { CareLevels, FacilityCategory, FacilityGetModel, FacilityItemType, FacilityPatchModel, MedicalNursings, Region } from "@/commons/services/Facilities";
import S3UrlService from "@/commons/services/S3Url";
import PublicS3UrlToBase64 from "@/commons/utils/PublicS3UrlToBase64";
import SystemError from "@/commons/models/SystemError";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormInputPostalCode from "@/pc/components/forms/FormInputPostalCode.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormFile from "@/pc/components/forms/FormFile.vue";
import FormImage from "@/pc/components/forms/FormImage.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import FormInputCheckboxes from "@/pc/components/forms/FormInputCheckboxes.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

/**
 * 施設画面コンポーネント
 */
@Component({
  components: {
    HelpIcon,
    OkCancelModal,
    OkModal,
    ValidationAlert,
    FormInput,
    FormInputPostalCode,
    FormInputSelect,
    FormFile,
    FormImage,
    FormCheck,
    FormInputCheckboxes,
    FormTextarea,
    PageLoading
  },
  $_veeValidate: { validator: "new" }
})
export default class FacilityEdit extends Vue {
  /** 施設サービス */
  @Inject("FacilitiesService") facilitiesService!: FacilitiesService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 更新確認モーダル表示可否 */
  showUpdateModal: boolean = false;
  /** 更新完了モーダル表示可否 */
  showUpdateSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 施設 */
  facility: FacilityGetModel | null = null;

  /** 施設名 */
  name: string = "";

  /** 郵便番号1 */
  postalCode1: string | null = null;
  /** 郵便番号2 */
  postalCode2: string | null = null;
  /** 都道府県 */
  prefectureCode: string | null = null;
  /** 市区町村 */
  municipalityCode: string | null = null;
  /** 丁目番地号 */
  streetAddress: string | null = null;

  /** 介護度（複数選択可能） */
  careLevels: CareLevels = {
    /** 自立 */
    careLevel1000: false,
    /** 申請中 */
    careLevel1010: false,
    /** 要支援１ */
    careLevel2010: false,
    /** 要支援２ */
    careLevel2020: false,
    /** 要介護1 */
    careLevel3010: false,
    /** 要介護2 */
    careLevel3020: false,
    /** 要介護3 */
    careLevel3030: false,
    /** 要介護4 */
    careLevel3040: false,
    /** 要介護5 */
    careLevel3050: false
  };
  /** 生活保護を受け入れるか否か */
  acceptsWelfare: boolean = false;
  /** 医療・看護体制 */
  medicalNursings: MedicalNursings = {
    /** 介護食 */
    nursingCareFood: false,
    /** 流動食・嚥下食 */
    liquidDysphagiaDiet: false,
    /** 糖尿病・インスリン */
    diabetesInsulin: false,
    /** 胃ろう */
    gastrostomy: false,
    /** 鼻腔・経管栄養 */
    nasogastricTube: false,
    /** ストーマ・人工肛門 */
    stomaOrColostomy: false,
    /** 在宅酸素療法 */
    homeOxygenTherapy: false,
    /** 人工呼吸器 */
    ventilator: false,
    /** 褥瘡・床ずれ */
    bedsore: false,
    /** たん吸引 */
    phlegmSuction: false,
    /** 人工透析 */
    dialysis: false,
    /** 気管切開 */
    tracheostomy: false,
    /** 中心静脈栄養 */
    totalParenteralNutrition: false,
    /** カテーテル・尿バルーン */
    urinaryCatheterOrBalloonCatheter: false,
    /** ペースメーカー */
    pacemaker: false
  };
  /** 受け入れ条件の補足事項 */
  acceptanceConditions: string = "";

  /** 電話番号 */
  tel: string = "";
  /** HPのURL */
  url: string = "";
  /** ファイル選択コンポーネントで選択したファイル */
  imageFile: any = "";
  /** ファイル選択コンポーネントで選択したファイルのURL */
  imageUrl: string = "";
  /** ファイル選択コンポーネントで選択したファイル名 */
  imageName: string = "";

  /** 施設種別 */
  facilityCategory: FacilityCategory | null = null;

  /** エラーメッセージ */
  errorMessage: string = "";

  /** 都道府県選択肢 */
  get _prefectureOptions(): Array<{ value: string; label: string }> {
    if (!regionsStore) {
      return [];
    }

    const options: Array<{ value: string; label: string }> = [];
    for (const region of regionsStore.regions) {
      // 登録する都道府県コードは先頭2桁なのでsliceする
      options.push({ value: region.prefecture.code.slice(0, 2), label: region.prefecture.name });
    }

    return options;
  }

  /** 都道府県選択肢 */
  get _municipalityOptions(): Array<{ value: string | null; label: string }> {
    if (!regionsStore) {
      return [];
    }

    if (!this.prefectureCode) {
      return [{ value: null, label: "都道府県を選択してください" }];
    }

    const options: Array<{ value: string; label: string }> = [];
    for (const region of regionsStore.regions) {
      if (region.prefecture.code.slice(0, 2) == this.prefectureCode) {
        for (const municipality of region.municipalities) {
          // 登録する都道府県コードは先頭2桁を除いた3桁なのでsliceする
          options.push({ value: municipality.code.slice(2, 5), label: municipality.name });
        }
      }
    }

    return options;
  }

  get _facilityCategoryOptions(): Array<{ value: string | null; label: string }> {
    return [
      { value: FacilityCategory.KAIGO_YUURYOU, label: "介護付有料老人ホーム" },
      { value: FacilityCategory.JYUUTAKU_YUURYOU, label: "住宅型有料老人ホーム" },
      { value: FacilityCategory.SERVICE_JYUUTAKU, label: "サービス付き高齢者向け住宅" },
      { value: FacilityCategory.CONDOMINIUMS, label: "シニア向け分譲マンション" },
      { value: FacilityCategory.GROUP_HOME, label: "グループホーム" },
      { value: FacilityCategory.CARE_HOUSE, label: "ケアハウス" },
      { value: FacilityCategory.TOKUYO, label: "特別養護老人ホーム（特養）" },
      { value: FacilityCategory.KAIGO_HOKEN, label: "介護老人保健施設（老健）" },
      { value: FacilityCategory.MEDICAL_CENTER, label: "介護医療院" },
      { value: FacilityCategory.OTHER, label: "その他" }
    ];
  }

  get _acceptsWelfareOptions(): Array<{ value: string | null; label: string }> {
    return [
      { value: FacilityCategory.KAIGO_YUURYOU, label: "介護付有料老人ホーム" },
      { value: FacilityCategory.JYUUTAKU_YUURYOU, label: "住宅型有料老人ホーム" },
      { value: FacilityCategory.SERVICE_JYUUTAKU, label: "サービス付き高齢者向け住宅" },
      { value: FacilityCategory.CONDOMINIUMS, label: "シニア向け分譲マンション" },
      { value: FacilityCategory.GROUP_HOME, label: "グループホーム" },
      { value: FacilityCategory.CARE_HOUSE, label: "ケアハウス" },
      { value: FacilityCategory.TOKUYO, label: "特別養護老人ホーム（特養）" },
      { value: FacilityCategory.KAIGO_HOKEN, label: "介護老人保健施設（老健）" },
      { value: FacilityCategory.MEDICAL_CENTER, label: "介護医療院" },
      { value: FacilityCategory.OTHER, label: "その他" }
    ];
  }

  get _medicalNursingsOptions(): Array<{ key: string; label: string; style: string }> {
    return [
      { key: "nursingCareFood", label: "介護食", style: "min-width:248px;" },
      { key: "liquidDysphagiaDiet", label: "流動食・嚥下食", style: "min-width:248px;" },
      { key: "diabetesInsulin", label: "糖尿病・インスリン", style: "min-width:248px;" },
      { key: "gastrostomy", label: "胃ろう", style: "min-width:248px;" },
      { key: "nasogastricTube", label: "鼻腔・経管栄養", style: "min-width:248px;" },
      { key: "stomaOrColostomy", label: "ストーマ・人工肛門", style: "min-width:248px;" },
      { key: "homeOxygenTherapy", label: "在宅酸素療法", style: "min-width:248px;" },
      { key: "ventilator", label: "人工呼吸器", style: "min-width:248px;" },
      { key: "bedsore", label: "褥瘡・床ずれ", style: "min-width:248px;" },
      { key: "phlegmSuction", label: "たん吸引", style: "min-width:248px;" },
      { key: "dialysis", label: "人工透析", style: "min-width:248px;" },
      { key: "tracheostomy", label: "気管切開", style: "min-width:248px;" },
      { key: "totalParenteralNutrition", label: "中心静脈栄養", style: "min-width:248px;" },
      { key: "urinaryCatheterOrBalloonCatheter", label: "カテーテル・尿バルーン", style: "min-width:248px;" },
      { key: "pacemaker", label: "ペースメーカー", style: "min-width:248px;" }
    ];
  }

  /** ### 都道府県の変更イベント */
  changePrefecture(): void {
    this.municipalityCode = null;
    this.streetAddress = null;
    return;
  }

  /** ### 市区町村の変更イベント */
  changeMunicipality(): void {
    this.streetAddress = null;
    return;
  }

  /**
   * vue lifecycle created
   */
  public created() {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    await this.createView();

    this.isBusy = false;

    return;
  }

  /**
   * 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    const facility: FacilityGetModel = await this.getFacility();
    this.facility = facility;

    // 施設名、電話番号、ホームページの格納
    this.name = this.facility.name;
    this.tel = this.facility.tel;
    this.url = this.facility.url;

    // 住所の格納
    // facilityDetails情報があれば使用する
    if (facility.facilityDetailInfo && facility.facilityDetailInfo.addressInfo) {
      // 郵便番号は3桁、4桁に分割する
      this.postalCode1 = facility.facilityDetailInfo.addressInfo.postalCode.slice(0, 3);
      this.postalCode2 = facility.facilityDetailInfo.addressInfo.postalCode.slice(3);

      this.streetAddress = facility.facilityDetailInfo.addressInfo.streetAddress;
    }
    if (facility.facilityDetailInfo && facility.facilityDetailInfo.region) {
      this.prefectureCode = facility.facilityDetailInfo.region.prefectureCode;
      this.municipalityCode = facility.facilityDetailInfo.region.municipalityCode;
    }
    // 施設種別の格納
    if (facility.facilityDetailInfo && facility.facilityDetailInfo.facilityCategory) {
      this.facilityCategory = facility.facilityDetailInfo.facilityCategory;
    }
    // ない場合は既存の情報を使用する
    else {
      this.streetAddress = this.facility.address;
    }

    // 画像の格納
    if (this.facility.imageUrl) {
      // 画像のURLの末尾がファイル名
      const imagePaths = this.facility.imageUrl.split("/");
      this.imageName = imagePaths[imagePaths.length - 1];
      // 画像URLが存在する場合は画像をBase64エンコードしたものを保持し、表示する
      const imageUrl: string = await this.convertImageUrl(this.facility.imageUrl);
      this.imageFile = await PublicS3UrlToBase64.convert(imageUrl, "image/jpeg");
      this.imageUrl = this.imageFile;
    }

    // 介護度の格納
    if (facility.facilityDetailAccept && facility.facilityDetailAccept.careLevels) {
      this.careLevels = facility.facilityDetailAccept.careLevels;
    }
    // 生活保護を受け入れるか否か
    if (facility.facilityDetailAccept && facility.facilityDetailAccept.acceptsWelfare) {
      this.acceptsWelfare = facility.facilityDetailAccept.acceptsWelfare ? true : false;
    }
    // 医療・看護体制
    if (facility.facilityDetailAccept && facility.facilityDetailAccept.medicalNursings) {
      this.medicalNursings = facility.facilityDetailAccept.medicalNursings;
    }
    // 受け入れ条件の補足事項
    if (facility.facilityDetailAccept && facility.facilityDetailAccept.acceptanceConditions) {
      this.acceptanceConditions = facility.facilityDetailAccept.acceptanceConditions;
    }

    return;
  }

  /**
   * 施設取得
   */
  public async getFacility(): Promise<FacilityGetModel> {
    const response: FacilityGetModel = await this.facilitiesService.get(userStore);
    return response;
  }

  /**
   * DBに保存されているS3URLを公開状態にし、公開状態にした画像のURLを返却する
   */
  public async convertImageUrl(imageUrl: string): Promise<string> {
    // 画像のURLがない場合は空を返す
    if (!imageUrl) {
      return "";
    }

    // 画像URL取得
    const convertImageUrl = await this.s3UrlService.get(userStore, Setting.backets.imageExpireHour, imageUrl);

    return convertImageUrl;
  }

  /**
   * FileSelecterコンポーネントにバインドした画像の変更イベント
   * ファイル選択、ファイル削除時に呼ばれる
   */
  @Watch("imageFile")
  public async changeImageFile(newFile: string): Promise<void> {
    if (newFile) {
      this.imageUrl = newFile;
    } else {
      this.imageUrl = "";
    }

    return;
  }

  /**
   * 登録確認モーダルを表示する
   * 表示前にバリデーションチェックして、エラーならモーダルは表示しない
   */
  public async showConfirmUpdateModal(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();

    if (validationResult) {
      this.showValidationAlert = false;
      this.showUpdateModal = true;
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * 施設更新
   */
  public async updateFacility(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const param: FacilityPatchModel = await this.createUpdateParam();
      await this.facilitiesService.patch(userStore, param);

      this.showUpdateSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      } else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * 施設更新パラメータ作成
   */
  public createUpdateParam(): FacilityPatchModel {
    const facility: FacilityGetModel = this.facility as FacilityGetModel;

    let prefecture = "";
    for (const prefectureOption of this._prefectureOptions) {
      if (prefectureOption.value == this.prefectureCode) {
        prefecture = prefectureOption.label;
        break;
      }
    }
    let municipality = "";
    for (const municipalityOption of this._municipalityOptions) {
      if (municipalityOption.value == this.municipalityCode) {
        municipality = municipalityOption.label;
        break;
      }
    }

    const facilityPatchModel: FacilityPatchModel = {
      name: this.$stringUtil.convertYen(this.name),
      tel: this.tel,
      url: this.url ? this.$stringUtil.convertYen(this.url) : "",
      imageUrl: this.imageFile,
      useAdmissionApplicationTemplateId: facility.useAdmissionApplicationTemplateId,
      useAdmissionJudgementTemplateId: facility.useAdmissionJudgementTemplateId,
      recruitmentRoom: facility.recruitmentRoom,

      facilityDetailInfo: {
        facilityId: facility.id,
        itemType: facility.facilityDetailInfo && facility.facilityDetailInfo.itemType ? facility.facilityDetailInfo.itemType : FacilityItemType.INFO,
        addressInfo: {
          postalCode: (this.postalCode1 as string) + (this.postalCode2 as string),
          prefecture: prefecture,
          municipality: municipality,
          streetAddress: this.streetAddress as string
        },
        facilityCategory: this.facilityCategory,
        region: {
          prefectureCode: this.prefectureCode as string,
          municipalityCode: this.municipalityCode as string
        },
        created: facility.created,
        updated: facility.updated
      },

      facilityDetailAccept: {
        facilityId: facility.id,
        itemType: facility.facilityDetailAccept && facility.facilityDetailAccept.itemType ? facility.facilityDetailAccept.itemType : FacilityItemType.ACCEPT,
        careLevels: this.careLevels,
        acceptsWelfare: this.acceptsWelfare ? this.acceptsWelfare : false,
        medicalNursings: this.medicalNursings,
        acceptanceConditions: this.acceptanceConditions,
        created: facility.created,
        updated: facility.updated
      },

      updated: facility.updated
    };

    return facilityPatchModel;
  }

  /**
   * 施設画面に遷移する
   */
  public gotoFacility(): void {
    this.$router.push(PcUrl.Facility);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

#facility-edit {
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;
  .note {
    margin: 0 20px 20px 20px;
  }
  .update-btn,
  .cancel-btn {
    width: 120px;
  }

  // 画像でセレクトボックスを表現するので、input要素自体は非表示にする
  input[type="checkbox"] {
    display: none;

    // input要素の代わりに画像つきのspanにする
    // 選択しているか否かで画像を切り替える
    // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
    & + span {
      // チェックボックス画像が全て表示されるように高さを指定する
      height: 46px;
      // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
      padding: 6px 0 0 40px;
      background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
      // チェックボックス画像のサイズを指定
      // 正方形なので要素の高さと同じになる
      background-size: 32px 32px;
    }
    &:checked + span {
      background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
      // チェックボックス画像のサイズを指定
      // 正方形なので要素の高さと同じになる
      background-size: 32px 32px;
    }
  }
}
</style>
